import React from 'react';

import SpotlioSocket from "./Spotlio";

import { getSystemSettings } from '../../../utils/SettingsRetriever';


export default () => {
    const configuration = getSystemSettings();
    let ClientSocket = false;
    if (configuration && configuration.socket && configuration.socket.component) ClientSocket = React.lazy(() => import("./" + configuration.socket.component));
    return (
        <React.Fragment>
            {ClientSocket && <ClientSocket />}
            <SpotlioSocket data={configuration} />
        </React.Fragment>
    )
};
